import Backbone from 'backbone';
import Handlebars from 'handlebars';

import EventHub from '~/eventHub';
import toastr from 'toastr';
import template from '~/templates/notifications.handlebars';

var NotificationsView = Backbone.View.extend({
	className: 'notifView',
	skip: null,
	alertsData: null,
	reportID: null,
	notifData: null,

	initialize: function() {
		
	},
	
	events: {
		'click .notif_load': 'loadPagination',
		'click .prorroga': 'prorrogaPopUp',
		'click .btnprorroga2': 'activateProrroga'
	},

	prorrogaPopUp: function(e) {
		this.reportID = $(e.currentTarget).attr('id');
		Parse.Cloud.run('DeleteProrrogaNotif', { reportID: this.reportID }).then(() => {

		},
		(error) => {
			console.log(error);
			switch(error.code){
				case 100:
					toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
				break;
			}
		});
		$('#ProrrogaReportID').text(this.reportID);
		var notifInfo = this.notifData.results;
		for(var i = 0; i < notifInfo.length; ++i){
			if(notifInfo[i].attributes.report.id == this.reportID){
				var report = notifInfo[i].attributes.report;
				console.log(report);
				var date = report.attributes.createdAt;
				date.setDate(date.getDate() + parseInt(this.notifData.delreportdata1));
				var content = '<span key="DelReportDataIntro">Por buenas practicas de protección de datos de los usuarios, el reporte: </span>'+ report.attributes.subCategory.attributes.superCat.attributes.name +' '+ report.attributes.subCategory.attributes.name +' <span key="DelReportDataDate">se eliminaran los datos en la fecha </span>'+ date.toLocaleDateString('en-GB') +'.<br><br><a class="reportlink" href="#report/'+ report.id +'" key="DelReportDataLink">Puede consultar el reporte aqui.</a><br><br><span key="DelReportDataProrroga">O también puede solicitar una prorroga unica por 90 días para atender el caso de ser necesario.</span>';
				$('#reportInfoContainer2').html(content);
			}
		}
	},

	activateProrroga: function(e) {
		Parse.Cloud.run("ActivateProrroga", { reportID: this.reportID }).then(function(response) {
			toastr.success(arrlang[lang]["SaveStateok"],"Operación realizada");
			$('#prorrogaModal').modal('hide');
			$('.modal-backdrop').remove();
		},
		function(error) {
			$('#prorrogaModal').modal('hide');
			$('.modal-backdrop').remove();
			console.log(error);
			switch(error.code){
				case 100:
					toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
				break;
			}
		});
	},
	
	render: function() {
		var that = this;
		this.skip = 0;
		var notifData = {
			userID: Parse.User.current().id,
			skip: this.skip
		};
		Parse.Cloud.run("GetAllNotifications", notifData).then((data) => {
			$('.notificationsloader').hide();
			that.notifData = data;
			var notifInfo = data.results;
			that.alertsData = notifInfo;
			var count = data.count;
			var delay = data.delay;
			var content = '';
			for(var i = 0; i < notifInfo.length; ++i){
				if(notifInfo[i].attributes.report){
					switch(notifInfo[i].attributes.kind){
						case 'newreport':
							content += '<div class="singlenotif"><a class="open_notif" id="'+ notifInfo[i].attributes.report.id +'" href="#report/'+ notifInfo[i].attributes.report.id +'"><img src="';
							if(notifInfo[i].attributes.report.attributes.subCategory.attributes.superCat.attributes.iconFile){
								content += notifInfo[i].attributes.report.attributes.subCategory.attributes.superCat.attributes.iconFile._url +'" alt="" class="report-img">';
							}
							else{
								content += 'images/new/icons/7sO96C21Pf.svg" alt="" class="report-img">';
							}
							content += '<div class="notif-info"><span class="notif-text"> Reporte nuevo de '+ notifInfo[i].attributes.report.attributes.subCategory.attributes.superCat.attributes.name +' '+ notifInfo[i].attributes.report.attributes.subCategory.attributes.name+' </span>';
						break;
						case 'comment':
							content += '<div class="singlenotif"><a class="open_notif" id="'+ notifInfo[i].attributes.report.id +'" href="#report/'+ notifInfo[i].attributes.report.id +'"><img src="';
							if(notifInfo[i].attributes.report.attributes.subCategory.attributes.superCat.attributes.iconFile){
								content += notifInfo[i].attributes.report.attributes.subCategory.attributes.superCat.attributes.iconFile._url +'" alt="" class="report-img">';
							}
							else{
								content += 'images/new/icons/7sO96C21Pf.svg" alt="" class="report-img">';
							}
							content += '<div class="notif-info"><span class="notif-text"> Comentario nuevo de '+ notifInfo[i].attributes.report.attributes.subCategory.attributes.superCat.attributes.name +' '+ notifInfo[i].attributes.report.attributes.subCategory.attributes.name+' </span>';
						break;
						case 'closereport':
							content += '<div class="singlenotif"><a class="open_notif" id="'+ notifInfo[i].attributes.report.id +'" href="#report/'+ notifInfo[i].attributes.report.id +'"><img src="';
							if(notifInfo[i].attributes.report.attributes.subCategory.attributes.superCat.attributes.iconFile){
								content += notifInfo[i].attributes.report.attributes.subCategory.attributes.superCat.attributes.iconFile._url +'" alt="" class="report-img">';
							}
							else{
								content += 'images/new/icons/7sO96C21Pf.svg" alt="" class="report-img">';
							}
							content += '<div class="notif-info"><span class="notif-text"> Reporte cerrado de '+ notifInfo[i].attributes.report.attributes.subCategory.attributes.superCat.attributes.name +' '+ notifInfo[i].attributes.report.attributes.subCategory.attributes.name+' </span>';
						break;
						case 'discardreport':
							content += '<div class="singlenotif"><a class="open_notif" id="'+ notifInfo[i].attributes.report.id +'" href="#report/'+ notifInfo[i].attributes.report.id +'"><img src="';
							if(notifInfo[i].attributes.report.attributes.subCategory.attributes.superCat.attributes.iconFile){
								content += notifInfo[i].attributes.report.attributes.subCategory.attributes.superCat.attributes.iconFile._url +'" alt="" class="report-img">';
							}
							else{
								content += 'images/new/icons/7sO96C21Pf.svg" alt="" class="report-img">';
							}
							content += '<div class="notif-info"><span class="notif-text"> Reporte descartado de '+ notifInfo[i].attributes.report.attributes.subCategory.attributes.superCat.attributes.name +' '+ notifInfo[i].attributes.report.attributes.subCategory.attributes.name+' </span>';
						break;
						case 'noresponse':
							content += '<div class="singlenotif"><a class="open_notif" id="'+ notifInfo[i].attributes.report.id +'" href="#report/'+ notifInfo[i].attributes.report.id +'"><img src="';
							if(notifInfo[i].attributes.report.attributes.subCategory.attributes.superCat.attributes.iconFile){
								content += notifInfo[i].attributes.report.attributes.subCategory.attributes.superCat.attributes.iconFile._url +'" alt="" class="report-img">';
							}
							else{
								content += 'images/new/icons/7sO96C21Pf.svg" alt="" class="report-img">';
							}
							content += '<div class="notif-info"><span class="notif-text">Reporte de '+ notifInfo[i].attributes.report.attributes.subCategory.attributes.superCat.attributes.name +' lleva mas de '+ delay +' dias sin recibir respuesta</span>';
						break;
						case 'deletereportdata':
							content += '<div class="singlenotif"><a class="open_notif" id="'+ notifInfo[i].attributes.report.id +'" href="#report/'+ notifInfo[i].attributes.report.id +'"><i class="fa fa-calendar-times report-icon""></i>';
							content += '<div class="notif-info"><span class="notif-text">Datos del reporte de '+ notifInfo[i].attributes.report.attributes.subCategory.attributes.superCat.attributes.name +' fueron eliminados</span>';
						break;
						case 'fordelete':
							content += '<div class="singlenotif"><a class="open_notif" id="'+ notifInfo[i].attributes.report.id +'" href="#report/'+ notifInfo[i].attributes.report.id +'"><i class="fa fa-calendar-times report-icon""></i>';
							content += '<div class="notif-info"><span class="notif-text">Datos del reporte de '+ notifInfo[i].attributes.report.attributes.subCategory.attributes.superCat.attributes.name +' pronto serán eliminados</span>';
						break;
						case 'prorroga':
							content += '<div class="singlenotif"><a class="open_notif prorroga" id="'+ notifInfo[i].attributes.report.id +'" data-toggle="modal" data-target="#prorrogaModal2"><i class="fa fa-calendar-times report-icon""></i>';
							content += '<div class="notif-info"><span class="notif-text">Datos del reporte de '+ notifInfo[i].attributes.report.attributes.subCategory.attributes.superCat.attributes.name +' pronto serán eliminados. Puede solicitar una prórroga aquí</span>';
						break;
					}
					var today = new Date();
					if(today.toLocaleDateString('en-GB') == notifInfo[i].createdAt.toLocaleDateString('en-GB')){
						content += '&nbsp;-&nbsp;<span class="notif-date">'+ arrlang[lang]["notifToday"]+ '</span></div>';
					}
					else{
						content += '&nbsp;-&nbsp;<span class="notif-date">'+ notifInfo[i].createdAt.toLocaleDateString('en-GB') +'</span></div>';
					}
					if(notifInfo[i].attributes.kind == 'noresponse'){
						content += '<i class="fa fa-exclamation-circle noresponseicon"></i>';
					}
					content += '</a></div>';
				}
			}
			if(count > 50){
				$(".notif_pagination").show();
			}
			$("#notif-view-container").html(content);
		},
		(error) => {
			console.log(error);
			switch(error.code){
				case 100:
					toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
				break;
			}
		});
		this.$el.html(Handlebars.template(template));
		this.translate();
		return this;
	},

	translate: function(e){
		if( lang !='es'){
			this.$el.find('.item').each(function(index, element){
				$(this).text(arrlang[lang][$(this).attr("key")]);
			});
		}
	},
	
	loadPagination: function() {
		var that = this;
		++this.skip;
		var notifData = {
			userID: Parse.User.current().id,
			skip: this.skip
		};
		Parse.Cloud.run("GetAllNotifications", notifData).then((data) => {
			that.notifData.results = that.notifData.results.concat(data.results);
			var notifInfo = data.results;
			var count = data.count;
			var delay = data.delay;
			var content = '';
			var repeatIndex = -1;
			for(var i = 0; i < that.alertsData.length; ++i){
				if(that.alertsData[i].id == notifInfo[0].id){
					repeatIndex = i;
				}
			}
			if(repeatIndex > -1){
				repeatIndex = 49-repeatIndex;
			}
			++repeatIndex;
			for(var i = repeatIndex; i < notifInfo.length; ++i){
				that.alertsData.push(notifInfo[i]);
				if(notifInfo[i].attributes.report){
					switch(notifInfo[i].attributes.kind){
						case 'newreport':
							content += '<div class="singlenotif"><a class="open_notif" id="'+ notifInfo[i].attributes.report.id +'" href="#report/'+ notifInfo[i].attributes.report.id +'"><img src="';
							if(notifInfo[i].attributes.report.attributes.subCategory.attributes.superCat.attributes.iconFile){
								content += notifInfo[i].attributes.report.attributes.subCategory.attributes.superCat.attributes.iconFile._url +'" alt="" class="report-img">';
							}
							else{
								content += 'images/new/icons/7sO96C21Pf.svg" alt="" class="report-img">';
							}
							content += '<div class="notif-info"><span class="notif-text"> Reporte nuevo de '+ notifInfo[i].attributes.report.attributes.subCategory.attributes.superCat.attributes.name +' '+ notifInfo[i].attributes.report.attributes.subCategory.attributes.name+' </span>';
						break;
						case 'comment':
							content += '<div class="singlenotif"><a class="open_notif" id="'+ notifInfo[i].attributes.report.id +'" href="#report/'+ notifInfo[i].attributes.report.id +'"><img src="';
							if(notifInfo[i].attributes.report.attributes.subCategory.attributes.superCat.attributes.iconFile){
								content += notifInfo[i].attributes.report.attributes.subCategory.attributes.superCat.attributes.iconFile._url +'" alt="" class="report-img">';
							}
							else{
								content += 'images/new/icons/7sO96C21Pf.svg" alt="" class="report-img">';
							}
							content += '<div class="notif-info"><span class="notif-text"> Comentario nuevo de '+ notifInfo[i].attributes.report.attributes.subCategory.attributes.superCat.attributes.name +' '+ notifInfo[i].attributes.report.attributes.subCategory.attributes.name+' </span>';
						break;
						case 'closereport':
							content += '<div class="singlenotif"><a class="open_notif" id="'+ notifInfo[i].attributes.report.id +'" href="#report/'+ notifInfo[i].attributes.report.id +'"><img src="';
							if(notifInfo[i].attributes.report.attributes.subCategory.attributes.superCat.attributes.iconFile){
								content += notifInfo[i].attributes.report.attributes.subCategory.attributes.superCat.attributes.iconFile._url +'" alt="" class="report-img">';
							}
							else{
								content += 'images/new/icons/7sO96C21Pf.svg" alt="" class="report-img">';
							}
							content += '<div class="notif-info"><span class="notif-text"> Reporte cerrado de '+ notifInfo[i].attributes.report.attributes.subCategory.attributes.superCat.attributes.name +' '+ notifInfo[i].attributes.report.attributes.subCategory.attributes.name+' </span>';
						break;
						case 'discardreport':
							content += '<div class="singlenotif"><a class="open_notif" id="'+ notifInfo[i].attributes.report.id +'" href="#report/'+ notifInfo[i].attributes.report.id +'"><img src="';
							if(notifInfo[i].attributes.report.attributes.subCategory.attributes.superCat.attributes.iconFile){
								content += notifInfo[i].attributes.report.attributes.subCategory.attributes.superCat.attributes.iconFile._url +'" alt="" class="report-img">';
							}
							else{
								content += 'images/new/icons/7sO96C21Pf.svg" alt="" class="report-img">';
							}
							content += '<div class="notif-info"><span class="notif-text"> Reporte descartado de '+ notifInfo[i].attributes.report.attributes.subCategory.attributes.superCat.attributes.name +' '+ notifInfo[i].attributes.report.attributes.subCategory.attributes.name+' </span>';
						break;
						case 'noresponse':
							content += '<div class="singlenotif"><a class="open_notif" id="'+ notifInfo[i].attributes.report.id +'" href="#report/'+ notifInfo[i].attributes.report.id +'"><img src="';
							if(notifInfo[i].attributes.report.attributes.subCategory.attributes.superCat.attributes.iconFile){
								content += notifInfo[i].attributes.report.attributes.subCategory.attributes.superCat.attributes.iconFile._url +'" alt="" class="report-img">';
							}
							else{
								content += 'images/new/icons/7sO96C21Pf.svg" alt="" class="report-img">';
							}
							content += '<div class="notif-info"><span class="notif-text">Reporte de '+ notifInfo[i].attributes.report.attributes.subCategory.attributes.superCat.attributes.name +' lleva mas de '+ delay +' dias sin recibir respuesta</span>';
						break;
						case 'deletereportdata':
							content += '<div class="singlenotif"><a class="open_notif" id="'+ notifInfo[i].attributes.report.id +'" href="#report/'+ notifInfo[i].attributes.report.id +'"><i class="fa fa-calendar-times report-icon""></i>';
							content += '<div class="notif-info"><span class="notif-text">Datos del reporte de '+ notifInfo[i].attributes.report.attributes.subCategory.attributes.superCat.attributes.name +' fueron eliminados</span>';
						break;
						case 'fordelete':
							content += '<div class="singlenotif"><a class="open_notif" id="'+ notifInfo[i].attributes.report.id +'" href="#report/'+ notifInfo[i].attributes.report.id +'"><i class="fa fa-calendar-times report-icon""></i>';
							content += '<div class="notif-info"><span class="notif-text">Datos del reporte de '+ notifInfo[i].attributes.report.attributes.subCategory.attributes.superCat.attributes.name +' pronto serán eliminados</span>';
						break;
						case 'prorroga':
							content += '<div class="singlenotif"><a class="open_notif prorroga" id="'+ notifInfo[i].attributes.report.id +'" data-toggle="modal" data-target="#prorrogaModal2"><i class="fa fa-calendar-times report-icon""></i>';
							content += '<div class="notif-info"><span class="notif-text">Datos del reporte de '+ notifInfo[i].attributes.report.attributes.subCategory.attributes.superCat.attributes.name +' pronto serán eliminados. Puede solicitar una prórroga aquí</span>';
						break;
					}
					var today = new Date();
					if(today.toLocaleDateString('en-GB') == notifInfo[i].createdAt.toLocaleDateString('en-GB')){
						content += '&nbsp;-&nbsp;<span class="notif-date">'+ arrlang[lang]["notifToday"]+ '</span></div>';
					}
					else{
						content += '&nbsp;-&nbsp;<span class="notif-date">'+ notifInfo[i].createdAt.toLocaleDateString('en-GB') +'</span></div>';
					}
					if(notifInfo[i].attributes.kind == 'noresponse'){
						content += '<i class="fa fa-exclamation-circle noresponseicon"></i>';
					}
					content += '</a></div>';
					$("#notif-view-container").append(content);
				}
			}
			if(count > 50* (that.skip+1)){
				$(".notif_pagination").show();
			}
			else{
				$(".notif_pagination").hide();
			}
		},
		(error) => {
			--that.skip;
			console.log(error);
			switch(error.code){
				case 100:
					toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
				break;
			}
		});
	},
});
export default NotificationsView;
